import moment from 'moment';
import {getDocumentLang} from '../main/utils';
import components from '../algolia';

export default {
  name: 'BlogPosts',
  components,
  data() {
    return {
      indexName: this.$algolia.indexPrefix + 'blog_posts',
      filterString: null
    };
  },
  methods: {
    formatDate(date) {
      return moment
        .unix(date)
        .locale(getDocumentLang())
        .format('MMMM D, YYYY');
    }
  }
};
